"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XYReducerDomainAxis = void 0;
const ml_spectra_processing_1 = require("ml-spectra-processing");
const react_1 = require("react");
const ChartContext_1 = require("../context/ChartContext");
var XYReducerDomainAxis;
(function (XYReducerDomainAxis) {
    XYReducerDomainAxis["XAxis"] = "XAxis";
    XYReducerDomainAxis["YAxis"] = "YAxis";
})(XYReducerDomainAxis || (exports.XYReducerDomainAxis = XYReducerDomainAxis = {}));
function useXYReduce(domainAxis) {
    const { width, xDomain, yDomain } = (0, ChartContext_1.useChartData)();
    return (0, react_1.useCallback)((data) => {
        const { x, y } = data;
        const [from, to] = domainAxis === XYReducerDomainAxis.XAxis ? xDomain : yDomain;
        return (0, ml_spectra_processing_1.xyReduce)({ x, y }, { from, to, nbPoints: width * 4, optimize: true });
    }, [domainAxis, width, xDomain, yDomain]);
}
exports.default = useXYReduce;
